<ngx-page-container>
  <h1>Materials</h1>
  <hr>
  <ngx-form-list #formList
    *ngIf="materialColumns != null"
    [columns]="materialColumns"
    [value]="data.materials"
    (editConfirm)="validate($event)"
  >
  </ngx-form-list>

</ngx-page-container>
